<template>
    <div class="row">
        <div class="col-map-filter">

            <filter-form
                ref="filter"
                :taxonomy="taxonomy"
                :query="query"
                :mode="mode"
                :focus="focus"
                @update="fetchProjects"
                @view="reflectView"
            />

            <div class="mt-2">
                <map-hint :lang="lang"></map-hint>
            </div>
        </div>

        <div class="col">

            <ul class="nav nav-tabs map-head rounded border-top" role="tablist">
                <li class="nav-item" role="presentation">
                    <button
                        class="nav-link"
                        aria-selected="true"
                        data-bs-toggle="tab"
                        :class="{active: mode == 'institutions'}"
                        @click="switchMode('institutions', 'MapWho')"
                    >
                        <strong>{{ trans('layers.research') }}</strong>
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button
                        class="nav-link"
                        aria-selected="false"
                        data-bs-toggle="tab"
                        :class="{active: mode == 'geo-focus'}"
                        @click="switchMode('geo-focus', 'MapWhere')"
                    >
                        <strong>{{ trans('regions.label') }}</strong>
                    </button>
                </li>
            </ul>

            <component
                :is="currentMap"
                :units="units"
                :institutions="institutions"
                :taxonomy="taxonomy"
                @filter="applyFilter"
                @focus="updateFocus"
                @scroll="scrollTo"
            />
            <!-- @scroll="scrollTo" -->

            <result-stats
                :stats="stats"
            />

            <a ref="result-anchor" class="top-anchor"></a>
            <result-list
                :projects="projects"
                :taxonomy="taxonomy"
                :query="query"
                :stats="stats"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { assign, merge } from 'lodash'
import { dataUrl, currentLang, trans } from './AppUtils'
import { toSearch, toModel } from './FilterModel'
import FilterForm from './FilterForm.vue'
import MapWho from './MapWho.vue'
import MapWhere from './MapWhere.vue'
import MapHint from './MapHint.vue'
import ResultList from './ResultList.vue'
import ResultStats from './ResultStats.vue'

const HTTP = axios.create()

export default {

    components: {
        FilterForm,
        MapWho,
        MapWhere,
        MapHint,
        ResultList,
        ResultStats,
    },

    data() {
        const params = document.location.search.substring(1)
        const query = toModel(new URLSearchParams(params))
        const mode = query['rel'] || 'institutions'

        // console.debug("MODEL", query)

        return {
            // busy: false,
            mode: mode,
            currentMap: (mode == 'geo-focus') ? 'MapWhere' : 'MapWho',
            query: query,
            institutions: [],
            units: [],
            projects: [],
            taxonomy: [],
            focus: {},  // spatial focus
            lang: currentLang(),
            stats: {
                projects: {
                    matches: 0,
                    total: null,
                }
            },
        }
    },

    computed: {
        isDev() {
            return ("production" == 'development')
        }
    },

    created() {
        this.fetchTaxonomy()

        // const app = this
        // window.addEventListener('popstate', function (ev) {
        //     const query = ev.state
        //     if (query) {
        //         app.query = query
        //     } else {
        //         app.query = {}
        //     }
        //     app.fetchProjects(app.query)
        // })

    },

    mounted() {
        this.fetchProjects(this.query)
        window.addEventListener('popstate', ev => {
            console.debug("POP HISTORY", ev.state)
            // this.applyFilter(ev.state, false)
        })
    },

    methods: {

        trans,

        async fetchTaxonomy() {
            const url = dataUrl("taxonomy", {lang: this.lang})
            const re = await HTTP.get(url.href)
            const taxonomy = re.data
            this.taxonomy = taxonomy
        },

        async fetchProjects(query, updateHistory = true) {
            // console.debug("FETCH", query)
            const search = new URLSearchParams(toSearch(query))
            const source = dataUrl("map", search)
            const re = await HTTP.get(source.href)
            this.projects = re.data.projects || []
            this.institutions = re.data.institutions || []
            this.units = re.data['geo-focus'] || []
            this.stats = re.data.dimensions
            this.query.limit = this.stats.projects.limit
            this.query = query
            if (updateHistory) {
                console.debug("PUSH HISTORY", query)
                this.pushHistory(query, '?' + search)
            }
        },

        async applyFilter(filter, updateHistory = true) {
            const query = {}
            assign(query, this.query)
            assign(query, filter)
            this.fetchProjects(query, updateHistory)
        },

        reflectView(view) {
            const query = {}
            assign(query, this.query, view)
            const search = new URLSearchParams(toSearch(query))
            this.pushHistory(query, '?' + search)
        },

        /** @deprecated */
        updateOffset(offset) {
            const query = {}
            merge(query, this.query)
            query.offset = offset
            const search = new URLSearchParams(toSearch(query))
            this.pushHistory(query, '?' + search)
        },

        updateFocus(focus) {
            // console.debug("FOCUS", focus)
            this.focus = focus
        },

        pushHistory(params, url) {
            let state = JSON.parse(JSON.stringify(params))

            window.history.pushState(state, "", url);

            // window.history.replaceState(state, "", url);
        },

        switchMode(mode, component) {
            this.currentMap = component
            this.query.rel = mode
            this.mode = mode
        },

        scrollTo(component) {
            // DISABLED
            return;

            if (component == 'result') {
                const node = this.$refs['result-anchor'] || null
                if (node) {
                    node.scrollIntoView()
                }
            }
        }

    }
}
</script>